import React from 'react';
import PropTypes from 'prop-types';

import ActionText from '../ActionText';
import Alert from '../Alert';

const OTPEAlert = ({
  isVisible,
  alertType,
  alertMessage,
  onTryAgain
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Alert alertType={alertType} message={alertMessage}>
      {alertType === 'ERROR' && (
        <ActionText
          id="twoFactorCode-resend-email"
          color="info"
          onClick={onTryAgain}
        >
          Intentar de nuevo
        </ActionText>
      )}
    </Alert>
  );
};

OTPEAlert.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  alertType: PropTypes.string,
  alertMessage: PropTypes.string.isRequired,
  onTryAgain: PropTypes.func.isRequired
};

OTPEAlert.defaultProps = {
  alertType: ''
};

export default OTPEAlert;
